//Configuracoes

import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import toast, { Toaster } from 'react-hot-toast';
import { 
  Store, Instagram, Clock, Bike, Save, 
  CreditCard, MapPin, Key, ShieldCheck, FileCode, Beaker, Info, Bot, Globe, MessageSquare, Volume2, Wrench, Calendar
} from 'lucide-react';

// Importando seus styled-components
import { 
  Switch, 
  SwitchContainer, 
  FileUploadLabel 
} from './styles/configuracao'; 

const Configuracoes = ({ dadosIniciais, onUpdate }) => {
  const [form, setForm] = useState({
    gateway_ativo: 'nenhum',
    efi_sandbox: 0,
    webchat_ativo: 0,
    audio_notificacao: localStorage.getItem('audio_notificacao') || 'https://assets.mixkit.co/active_storage/sfx/2257/2257-preview.mp3',
    manutencao_ativa: 0,
    manutencao_tipo: 'manual', 
    manutencao_fim: '',
    manutencao_dias: 1,
    manutencao_mensagem: 'Estamos em manutenção programada para melhorias. Retornamos em breve!'
  });
  
  const [loading, setLoading] = useState(false);
  const [bots, setBots] = useState([]);
  const [loadingBots, setLoadingBots] = useState(false);

  // Carregamento Inicial dos Dados
  useEffect(() => {
    if (dadosIniciais) {
      let dataVencFormatada = "";
      if (dadosIniciais.data_vencimento) {
        dataVencFormatada = dadosIniciais.data_vencimento.split('T')[0];
      }

      let manutencaoFimFormatada = "";
      if (dadosIniciais.manutencao_fim) {
        manutencaoFimFormatada = dadosIniciais.manutencao_fim.slice(0, 16); 
      }

      // Correção do formato de horas vindas do banco (HH:mm:ss -> HH:mm)
      let horarioAberturaFmt = dadosIniciais.horario_abertura ? dadosIniciais.horario_abertura.slice(0, 5) : "";
      let horarioFechamentoFmt = dadosIniciais.horario_fechamento ? dadosIniciais.horario_fechamento.slice(0, 5) : "";

      setForm({
        ...dadosIniciais,
        data_vencimento: dataVencFormatada,
        nome: dadosIniciais.nome || "",
        whatsapp: dadosIniciais.whatsapp || "",
        documento: dadosIniciais.documento || "",
        cep: dadosIniciais.cep || "",
        rua: dadosIniciais.rua || "",
        numero: dadosIniciais.numero || "",
        bairro: dadosIniciais.bairro || "",
        cidade: dadosIniciais.cidade || "",
        estado: dadosIniciais.estado || "",
        instagram: dadosIniciais.instagram || "",
        site_oficial: dadosIniciais.site_oficial || "",
        faz_delivery: !!dadosIniciais.faz_delivery ? 1 : 0,
        entrega_metodo: dadosIniciais.entrega_metodo || 'raio',
        taxa_base_delivery: dadosIniciais.taxa_base_delivery || 0,
        km_maximo: dadosIniciais.km_maximo || 0,
        lat: dadosIniciais.lat || "", 
        lng: dadosIniciais.lng || "", 
        horario_abertura: horarioAberturaFmt,
        horario_fechamento: horarioFechamentoFmt,
        gateway_ativo: dadosIniciais.gateway_ativo || 'nenhum',
        efi_sandbox: !!dadosIniciais.efi_sandbox ? 1 : 0,
        efi_client_id: dadosIniciais.efi_client_id || "",
        efi_client_secret: dadosIniciais.efi_client_secret || "",
        efi_chave_pix: dadosIniciais.efi_chave_pix || "",
        mp_access_token: dadosIniciais.mp_access_token || "",
        ps_email: dadosIniciais.ps_email || "",
        ps_token: dadosIniciais.ps_token || "",
        pix_chave_tipo: dadosIniciais.pix_chave_tipo || 'cpf',
        pix_chave: dadosIniciais.pix_chave || '',
        pix_beneficiario: dadosIniciais.pix_beneficiario || dadosIniciais.nome || '',
        pix_cidade: dadosIniciais.pix_cidade || dadosIniciais.cidade || '',
        webchat_ativo: !!dadosIniciais.webchat_ativo ? 1 : 0,
        manutencao_ativa: !!dadosIniciais.manutencao_ativa ? 1 : 0,
        manutencao_tipo: dadosIniciais.manutencao_tipo || 'manual',
        manutencao_fim: manutencaoFimFormatada || '',
        manutencao_dias: dadosIniciais.manutencao_dias || 1,
        manutencao_mensagem: dadosIniciais.manutencao_mensagem || 'Estamos em manutenção programada para melhorias. Retornamos em breve!',
        audio_notificacao: localStorage.getItem('audio_notificacao') || 'https://assets.mixkit.co/active_storage/sfx/2257/2257-preview.mp3'
      });
    }
  }, [dadosIniciais]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const val = type === 'checkbox' ? (checked ? 1 : 0) : value;
  
    setForm(prev => ({
      ...prev,
      [name]: val
    }));

    if (name === 'audio_notificacao') {
      localStorage.setItem('audio_notificacao', val);
    }
  };

  const handleDiasManutencaoChange = (e) => {
    const dias = parseInt(e.target.value) || 1;
    const dataFutura = new Date();
    dataFutura.setDate(dataFutura.getDate() + dias);
    
    setForm(prev => ({
      ...prev,
      manutencao_dias: dias,
      manutencao_fim: dataFutura.toISOString().slice(0, 16)
    }));
  };

  const testarAudio = (url) => {
    const audio = new Audio(url || form.audio_notificacao);
    audio.play().catch(e => toast.error("Erro ao reproduzir áudio de teste"));
  };

  const handleCEP = async (e) => {
    const cep = e.target.value.replace(/\D/g, "");
    setForm(prev => ({ ...prev, cep }));

    if (cep.length === 8) {
      try {
        const res = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
        const data = await res.json();
        if (!data.erro) {
          setForm(prev => ({
            ...prev,
            rua: data.logradouro,
            bairro: data.bairro,
            cidade: data.localidade,
            estado: data.uf
          }));
          toast.success("Endereço localizado!");
        } else {
          toast.error("CEP não encontrado.");
        }
      } catch (err) {
        console.error("Erro ao buscar CEP", err);
      }
    }
  };

  const fetchBots = async () => {
    try {
      setLoadingBots(true);
      const res = await api.get(`/whatsapp/bot/fluxos/${dadosIniciais.id}`);
      setBots(res.data || []);
    } catch (err) {
      toast.error("Erro ao carregar bots");
    } finally {
      setLoadingBots(false);
    }
  };

  useEffect(() => {
    if (dadosIniciais?.id) {
      fetchBots();
    }
  }, [dadosIniciais]);

  const handleUploadCertificado = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const formData = new FormData();
    formData.append('file', file);
    formData.append('estabelecimento_id', dadosIniciais.id);
    try {
      setLoading(true);
      const res = await api.post('/cardapio/upload-cert', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      setForm(prev => ({ ...prev, efi_cert_path: res.data.path }));
      toast.success("Certificado enviado!");
    } catch (err) {
      toast.error("Falha no upload do certificado.");
    } finally {
      setLoading(false);
    }
  };
  
  const toggleBotStatus = async (botId, statusAtual) => {
    try {
      const novoStatus = statusAtual ? 0 : 1;
      await api.put(`/whatsapp/bot/status/${botId}`, { status: novoStatus });
      setBots(prev => prev.map(b => b.id === botId ? { ...b, status: novoStatus } : b));
      toast.success(novoStatus ? "Bot ativado" : "Bot desativado");
    } catch (err) {
      toast.error("Erro ao atualizar status do bot");
    }
  };

  const handleSubmit = async (e) => {
    if (e) e.preventDefault();
    if (form.gateway_ativo === 'efi' && (!form.efi_cert_path || !form.efi_chave_pix)) {
      toast.error("Dados da Efí incompletos.");
      return;
    }

    if (form.gateway_ativo === 'pix_direto' && (!form.pix_chave || !form.pix_beneficiario)) {
      toast.error("Preencha a chave Pix e o nome do beneficiário.");
      return;
    }

    setLoading(true);
    try {
      const payload = {
        ...form,
        faz_delivery: form.faz_delivery ? 1 : 0,
        efi_sandbox: form.efi_sandbox ? 1 : 0,
        webchat_ativo: form.webchat_ativo ? 1 : 0,
        manutencao_ativa: form.manutencao_ativa ? 1 : 0 
      };

      await api.put(`/cardapio/estabelecimentos/${dadosIniciais.id}`, payload);
      localStorage.setItem('audio_notificacao', form.audio_notificacao);
      toast.success("Configurações salvas!");
      
      if (onUpdate) onUpdate(payload);
    } catch (err) {
      console.error("Erro ao salvar:", err);
      toast.error("Erro ao salvar alterações.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="tab-content animate-fade-in">
      <Toaster position="top-right" containerStyle={{ zIndex: 999999 }} />

      <div className="header-flex">
        <h2 className="content-title">Painel de Controle do Estabelecimento</h2>
        <button onClick={handleSubmit} className="btn-save-fixed" disabled={loading}>
          <Save size={20} /> {loading ? "Processando..." : "Salvar Configurações"}
        </button>
      </div>

      <div className="config-grid-layout" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '20px', alignItems: 'stretch' }}>

        {/* --- SEÇÃO 1: DADOS BÁSICOS --- */}
        <div className="config-card" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
          <div className="card-header">
            <Store className="icon-red" size={22} />
            <h3>Identidade da Loja</h3>
          </div>
          <div className="card-body" style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
            <div>
              <div className="input-group">
                <label>Nome do Estabelecimento</label>
                <input name="nome" value={form.nome || ""} onChange={handleChange} />
              </div>
              <div className="input-group">
                <label>WhatsApp</label>
                <input name="whatsapp" value={form.whatsapp || ""} onChange={handleChange} />
              </div>
              <div className="input-group">
                <label>Documento (CNPJ/CPF)</label>
                <input name="documento" value={form.documento || ""} readOnly className="input-readonly" />
              </div>
            </div>
          </div>
        </div>

        {/* --- SEÇÃO 2: REDES SOCIAIS --- */}
        <div className="config-card" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
          <div className="card-header">
            <Instagram className="icon-red" size={22} />
            <h3>Redes e Links</h3>
          </div>
          <div className="card-body" style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
            <div>
              <div className="input-group">
                <label>Instagram</label>
                <input name="instagram" value={form.instagram || ""} onChange={handleChange} />
              </div>
              <div className="input-group">
                <label>Site Oficial</label>
                <input name="site_oficial" value={form.site_oficial || ""} onChange={handleChange} />
              </div>
            </div>
          </div>
        </div>

        {/* --- SEÇÃO 3: LOGÍSTICA --- */}
        <div className="config-card" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
          <div className="card-header">
            <Bike className="icon-red" size={22} />
            <h3>Entrega e Delivery</h3>
          </div>
          <div className="card-body" style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
            <div>
              <SwitchContainer style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '15px' }}>
                <label style={{ margin: 0, fontSize: '13px', fontWeight: '500' }}>Habilitar Pedidos para Delivery?</label>
                <Switch>
                  <input 
                    type="checkbox" 
                    name="faz_delivery" 
                    checked={!!form.faz_delivery} 
                    onChange={handleChange} 
                  />
                  <span className="slider"></span>
                </Switch>
              </SwitchContainer>

              <div className="delivery-method-badge" style={{
                backgroundColor: '#f0f0ff',
                padding: '10px',
                borderRadius: '8px',
                border: '1px solid #d1d1f7',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                fontSize: '13px'
              }}>
                <Info size={16} color="#6366f1" />
                <span>
                  Método atual: <strong>{form.entrega_metodo === 'raio' ? 'Raio por KM' : 'Bairros Fixos'}</strong> 
                  <br/>
                  <small style={{color: '#666'}}>Altere as taxas na aba "Taxas de Entrega".</small>
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* --- SEÇÃO 4: FUNCIONAMENTO (Horários) --- */}
        <div className="config-card" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
          <div className="card-header">
            <Clock className="icon-red" size={22} />
            <h3>Horários de Operação</h3>
          </div>
          <div className="card-body" style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
            <div className="form-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
              <div className="input-group" style={{ margin: 0 }}>
                <label>Abertura</label>
                <input type="time" name="horario_abertura" value={form.horario_abertura || ""} onChange={handleChange} />
              </div>
              <div className="input-group" style={{ margin: 0 }}>
                <label>Fechamento</label>
                <input type="time" name="horario_fechamento" value={form.horario_fechamento || ""} onChange={handleChange} />
              </div>
            </div>
          </div>
        </div>
        
        {/* --- SEÇÃO DE SOM DE NOTIFICAÇÃO --- */}
        <div className="config-card" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
          <div className="card-header">
            <Volume2 className="icon-red" size={22} />
            <h3>Som de Notificação</h3>
          </div>
          <div className="card-body" style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <div className="input-group" style={{ margin: 0 }}>
                <label>Escolha o Som de Alerta</label>
                <select 
                  name="audio_notificacao" 
                  value={form.audio_notificacao || ''} 
                  onChange={handleChange}
                  className="select-gateway"
                  style={{ width: '100%', height: '42px' }}
                >
                  <option value="https://assets.mixkit.co/active_storage/sfx/2257/2257-preview.mp3">Padrão (Campainha)</option>
                  <option value="https://assets.mixkit.co/active_storage/sfx/2869/2869-preview.mp3">Alerta Digital (Beep)</option>
                  <option value="https://assets.mixkit.co/active_storage/sfx/2354/2354-preview.mp3">Sino de Caixa</option>
                  <option value="https://assets.mixkit.co/active_storage/sfx/2213/2213-preview.mp3">Toque Suave (Chime)</option>
                </select>
              </div>
              <div>
                <button 
                  type="button" 
                  onClick={() => testarAudio(form.audio_notificacao)}
                  style={{
                    background: '#2563eb',
                    color: '#ffffff',
                    border: 'none',
                    borderRadius: '8px',
                    padding: '0 15px',
                    fontSize: '13px',
                    fontWeight: '600',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px',
                    height: '38px',
                    width: '100%',
                    transition: 'background 0.2s'
                  }}
                >
                  🔊 Testar Som de Alerta
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* --- SEÇÃO 7: BOTS --- */}
        <div className="config-card" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
          <div className="card-header">
            <Bot className="icon-red" size={22} />
            <h3>Automação / Bots</h3>
          </div>
          <div className="card-body" style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
            {loadingBots ? (
              <p style={{ fontSize: '13px', color: '#666' }}>Carregando bots...</p>
            ) : bots.length === 0 ? (
              <p style={{ fontSize: '13px', color: '#666' }}>Nenhum bot criado ainda.</p>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', maxHeight: '140px', overflowY: 'auto' }}>
                {bots.map(bot => (
                  <div
                    key={bot.id}
                    style={{
                      border: '1px solid #eee',
                      borderRadius: '10px',
                      padding: '10px 12px',
                      background: '#fff',
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      boxShadow: '0 1px 3px rgba(0,0,0,0.03)'
                    }}
                  >
                    <span style={{ fontWeight: '600', fontSize: '13px' }}>🤖 {bot.nome_fluxo}</span>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <span style={{ fontSize: '11px', color: bot.status ? '#2ecc71' : '#999' }}>
                        {bot.status ? 'Ativo' : 'Desativado'}
                      </span>
                      <Switch>
                        <input
                          type="checkbox"
                          checked={!!bot.status}
                          onChange={() => toggleBotStatus(bot.id, bot.status)}
                        />
                        <span className="slider"></span>
                      </Switch>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
         
        {/* --- WEBCHAT --- */}
        <div className="config-card" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
          <div className="card-header">
            <Globe className="icon-red" size={22} />
            <h3>Widget de Webchat (Site)</h3>
          </div>
          <div className="card-body" style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: '#f8f9fa', padding: '12px', borderRadius: '10px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <div style={{ background: form.webchat_ativo ? '#00a884' : '#ccc', padding: '8px', borderRadius: '50%', color: '#fff', display: 'flex' }}>
                  <MessageSquare size={18} />
                </div>
                <div>
                  <h4 style={{ margin: 0, fontSize: '13px', fontWeight: '600' }}>Exibir Chat no Site?</h4>
                  <p style={{ margin: 0, fontSize: '11px', color: '#666' }}>Balão de atendimento visível.</p>
                </div>
              </div>
              <Switch>
                <input 
                  type="checkbox" 
                  name="webchat_ativo" 
                  checked={!!form.webchat_ativo} 
                  onChange={handleChange} 
                />
                <span className="slider"></span>
              </Switch>
            </div>
          </div>
        </div>

        {/* --- SEÇÃO MODO MANUTENÇÃO --- */}
        <div className="config-card" style={{ display: 'flex', flexDirection: 'column', height: '100%', border: form.manutencao_ativa ? '2px solid #e11d48' : '1px solid #eee' }}>
          <div className="card-header">
            <Wrench className="icon-red" size={22} />
            <h3>Modo Manutenção</h3>
          </div>
          <div className="card-body" style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: form.manutencao_ativa ? '#fff1f2' : '#f8f9fa', padding: '12px', borderRadius: '10px', marginBottom: '12px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <div style={{ background: form.manutencao_ativa ? '#e11d48' : '#ccc', padding: '8px', borderRadius: '50%', color: '#fff', display: 'flex' }}>
                    <Wrench size={18} />
                  </div>
                  <div>
                    <h4 style={{ margin: 0, fontSize: '13px', color: form.manutencao_ativa ? '#9f1239' : '#111', fontWeight: '600' }}>
                      {form.manutencao_ativa ? '⚠️ Manutenção Ativa' : 'Ativar Manutenção?'}
                    </h4>
                    <p style={{ margin: 0, fontSize: '11px', color: '#666' }}>Oculta o cardápio dos clientes.</p>
                  </div>
                </div>
                <Switch>
                  <input 
                    type="checkbox" 
                    name="manutencao_ativa" 
                    checked={!!form.manutencao_ativa} 
                    onChange={handleChange} 
                  />
                  <span className="slider"></span>
                </Switch>
              </div>

              {form.manutencao_ativa === 1 && (
                <div className="animate-slide-down" style={{ background: '#fff', padding: '12px', borderRadius: '10px', border: '1px solid #fecdd3' }}>
                  <div className="input-group" style={{ marginBottom: '10px' }}>
                    <label style={{ fontSize: '12px' }}>Tipo de Término</label>
                    <select name="manutencao_tipo" value={form.manutencao_tipo || 'manual'} onChange={handleChange} className="select-gateway" style={{ fontSize: '12px' }}>
                      <option value="manual">Manual (Desativar quando quiser)</option>
                      <option value="periodo">Agendado por Dias / Período</option>
                    </select>
                  </div>

                  {form.manutencao_tipo === 'periodo' && (
                    <>
                      <div className="input-group" style={{ marginBottom: '10px' }}>
                        <label style={{ fontSize: '12px' }}>Duração em Dias</label>
                        <input 
                          type="number" 
                          min="1" 
                          max="365" 
                          name="manutencao_dias" 
                          value={form.manutencao_dias || 1} 
                          onChange={handleDiasManutencaoChange} 
                        />
                      </div>
                      <div className="input-group" style={{ marginBottom: '10px' }}>
                        <label style={{ fontSize: '12px' }}><Calendar size={12} /> Data/Hora de Retorno</label>
                        <input 
                          type="datetime-local" 
                          name="manutencao_fim" 
                          value={form.manutencao_fim || ''} 
                          onChange={handleChange} 
                        />
                      </div>
                    </>
                  )}

                  <div className="input-group" style={{ margin: 0 }}>
                    <label style={{ fontSize: '12px' }}>Mensagem aos Clientes</label>
                    <textarea 
                      name="manutencao_mensagem" 
                      value={form.manutencao_mensagem || ''} 
                      onChange={handleChange} 
                      rows={2}
                      style={{ width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #ccc', resize: 'vertical', fontSize: '12px' }}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

                <div className="config-card endereco-card">
            <div className="card-header">
                <MapPin className="icon-red" size={22} />
                <h3>Endereço Físico</h3>
            </div>
        
            <div className="card-body endereco-body">
        
                <div className="input-group">
                    <label>CEP</label>
                    <input
                        name="cep"
                        maxLength="8"
                        value={form.cep || ""}
                        onChange={handleCEP}
                    />
                </div>
        
                <div className="input-group">
                    <label>Rua / Logradouro</label>
                    <input
                        name="rua"
                        value={form.rua || ""}
                        onChange={handleChange}
                    />
                </div>
        
                <div className="grid-2">
                    <div className="input-group">
                        <label>Número</label>
                        <input
                            name="numero"
                            value={form.numero || ""}
                            onChange={handleChange}
                        />
                    </div>
        
                    <div className="input-group">
                        <label>Bairro</label>
                        <input
                            name="bairro"
                            value={form.bairro || ""}
                            onChange={handleChange}
                        />
                    </div>
                </div>
        
                <div className="grid-cidade">
                    <div className="input-group">
                        <label>Cidade</label>
                        <input
                            name="cidade"
                            value={form.cidade || ""}
                            onChange={handleChange}
                        />
                    </div>
        
                    <div className="input-group">
                        <label>UF</label>
                        <input
                            name="estado"
                            maxLength="2"
                            value={form.estado || ""}
                            onChange={handleChange}
                        />
                    </div>
                </div>
        
            </div>
        </div>

        {/* --- GATEWAYS DE PAGAMENTO (Reestruturado com padding interno correto para evitar vazamentos) --- */}
        <div className="config-card" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
          <div className="card-header">
            <CreditCard className="icon-red" size={22} />
            <h3>Configuração de Pagamento Online</h3>
          </div>
          <div className="card-body" style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
            <div style={{ width: '100%', boxSizing: 'border-box' }}>
              <div className="input-group">
                <label>Selecione o Gateway Ativo</label>
                <select 
                  name="gateway_ativo" 
                  value={form.gateway_ativo} 
                  onChange={handleChange}
                  className="select-gateway"
                >
                  <option value="nenhum">Desativar Pagamento Online</option>
                  <option value="mercadopago">Mercado Pago</option>
                  <option value="pagseguro">PagSeguro (PagBank)</option>
                  <option value="efi">Efí Bank (Gerencianet)</option>
                  <option value="pix_direto">Pix Direto (Receba na sua Chave Pix)</option>
                </select>
              </div>
  
              {form.gateway_ativo !== 'nenhum' && form.gateway_ativo !== 'pix_direto' && (
                <SwitchContainer style={{ marginTop: '15px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <label style={{ margin: 0, fontSize: '13px' }}>Ambiente de Transação</label>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <Switch>
                      <input 
                        type="checkbox" 
                        name="efi_sandbox" 
                        checked={!!form.efi_sandbox} 
                        onChange={handleChange} 
                      />
                      <span className="slider"></span>
                    </Switch>
                    {form.efi_sandbox ? (
                      <span style={{ color: '#ffa117', display: 'flex', alignItems: 'center', gap: '4px', fontSize: '12px' }}>
                        <Beaker size={14} /> Sandbox
                      </span>
                    ) : (
                      <span style={{ color: '#2ecc71', display: 'flex', alignItems: 'center', gap: '4px', fontSize: '12px' }}>
                        <ShieldCheck size={14} /> Produção
                      </span>
                    )}
                  </div>
                </SwitchContainer>
              )}
  
              {form.gateway_ativo === 'mercadopago' && (
                <div className="gateway-box mp-border animate-slide-down" style={{ marginTop: '15px', width: '100%', boxSizing: 'border-box' }}>
                  <div className="input-group" style={{ margin: 0 }}>
                    <label><Key size={14} /> Access Token</label>
                    <input type="password" name="mp_access_token" value={form.mp_access_token || ""} onChange={handleChange} />
                  </div>
                </div>
              )}
  
              {form.gateway_ativo === 'pagseguro' && (
                <div className="gateway-box ps-border animate-slide-down" style={{ marginTop: '15px', width: '100%', boxSizing: 'border-box' }}>
                  <div className="form-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
                    <div className="input-group" style={{ margin: 0 }}>
                      <label>E-mail da Conta</label>
                      <input name="ps_email" value={form.ps_email || ""} onChange={handleChange} />
                    </div>
                    <div className="input-group" style={{ margin: 0 }}>
                      <label>Token</label>
                      <input type="password" name="ps_token" value={form.ps_token || ""} onChange={handleChange} />
                    </div>
                  </div>
                </div>
              )}
  
              {form.gateway_ativo === 'efi' && (
                <div className="gateway-box efi-border animate-slide-down" style={{ marginTop: '15px', width: '100%', boxSizing: 'border-box' }}>
                  <div className="form-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '10px' }}>
                    <div className="input-group" style={{ margin: 0 }}>
                      <label>Client ID</label>
                      <input name="efi_client_id" value={form.efi_client_id || ""} onChange={handleChange} />
                    </div>
                    <div className="input-group" style={{ margin: 0 }}>
                      <label>Client Secret</label>
                      <input type="password" name="efi_client_secret" value={form.efi_client_secret || ""} onChange={handleChange} />
                    </div>
                  </div>
                  <div className="input-group" style={{ marginBottom: '10px' }}>
                    <label><Key size={14} /> Chave Pix Efí</label>
                    <input name="efi_chave_pix" value={form.efi_chave_pix || ""} onChange={handleChange} placeholder="Chave Pix" />
                  </div>
                  <div className="input-group" style={{ margin: 0 }}>
                    <FileUploadLabel htmlFor="file-cert">
                      <FileCode size={16} />
                      {form.efi_cert_path ? "Certificado: " + form.efi_cert_path.split('/').pop() : "Selecionar Certificado .p12"}
                      <input id="file-cert" type="file" accept=".p12" onChange={handleUploadCertificado} hidden />
                    </FileUploadLabel>
                    {form.efi_cert_path && (
                      <span style={{ color: '#2ecc71', fontSize: '11px', marginTop: '4px', display: 'flex', alignItems: 'center', gap: '4px' }}>
                        <ShieldCheck size={12} /> Pronto no servidor.
                      </span>
                    )}
                  </div>
                </div>
              )}

              {form.gateway_ativo === 'pix_direto' && (
                <div className="gateway-box animate-slide-down" style={{ background: '#f8fff9', padding: '12px', borderRadius: '10px', marginTop: '15px', border: '1px solid #d4edda', width: '100%', boxSizing: 'border-box' }}>
                  <h4 style={{ margin: '0 0 6px 0', color: '#27ae60', fontSize: '13px', display: 'flex', alignItems: 'center', gap: '6px', fontWeight: '600' }}>
                    <ShieldCheck size={16} /> Pix Direto (Banco Central)
                  </h4>
                  <p style={{ fontSize: '11px', color: '#555', marginBottom: '10px', lineHeight: '1.4' }}>
                    O QR Code é gerado dinamicamente. O pagamento vai direto para sua conta.
                  </p>

                  <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', width: '100%' }}>
                    <div className="input-group" style={{ margin: 0 }}>
                      <label style={{ fontSize: '11px' }}>Tipo de Chave</label>
                      <select name="pix_chave_tipo" value={form.pix_chave_tipo || 'cpf'} onChange={handleChange} className="select-gateway" style={{ fontSize: '12px', width: '100%', boxSizing: 'border-box' }}>
                        <option value="cpf">CPF</option>
                        <option value="cnpj">CNPJ</option>
                        <option value="email">E-mail</option>
                        <option value="telefone">Telefone</option>
                        <option value="aleatoria">Aleatória</option>
                      </select>
                    </div>

                    <div className="input-group" style={{ margin: 0 }}>
                      <label style={{ fontSize: '11px' }}>Sua Chave Pix</label>
                      <input name="pix_chave" value={form.pix_chave || ""} onChange={handleChange} placeholder="Digite a chave" style={{ fontSize: '12px', width: '100%', boxSizing: 'border-box' }} />
                    </div>

                    <div className="input-group" style={{ margin: 0 }}>
                      <label style={{ fontSize: '11px' }}>Titular (Beneficiário)</label>
                      <input name="pix_beneficiario" value={form.pix_beneficiario || ""} onChange={handleChange} placeholder="Nome no banco" style={{ fontSize: '12px', width: '100%', boxSizing: 'border-box' }} />
                    </div>

                    <div className="input-group" style={{ margin: 0 }}>
                      <label style={{ fontSize: '11px' }}>Cidade da Conta</label>
                      <input name="pix_cidade" value={form.pix_cidade || ""} onChange={handleChange} placeholder="Ex: Campinas" style={{ fontSize: '12px', width: '100%', boxSizing: 'border-box' }} />
                    </div>
                  </div>
                </div>
              )}
            </div>
  
            <div className="security-info" style={{ marginTop: '15px', display: 'flex', alignItems: 'center', gap: '6px', color: '#666', fontSize: '11px' }}>
              <ShieldCheck size={14} />
              <span>Credenciais criptografadas via HTTPS.</span>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}

export default Configuracoes;